import { createContext } from 'react';
import { PageContextType } from './types';

export const PageContext = createContext<PageContextType | undefined>(undefined);